import { useState, useEffect } from 'react';
import { useBusiness } from '../../../contexts/BusinessContext';
import { ticketTemplates } from '../../../services/ticketTemplates';
import { ticketRenderer } from '../../../services/ticketRenderer';

/**
 * Componente para mostrar una vista previa del ticket
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.sale - Datos de la venta
 * @param {string} props.type - Tipo de ticket (delivery, fulfillment, backup)
 * @param {string} props.className - Clases CSS adicionales
 */
export function TicketPreview({ sale, type = 'delivery', className = '' }) {
  const { business } = useBusiness();
  const [ticketContent, setTicketContent] = useState('');

  useEffect(() => {
    if (!sale || !business) {
      setTicketContent('No hay información suficiente para generar el ticket');
      return;
    }

    // Preparar los datos para el ticket
    const customer = sale.customer_name ? { name: sale.customer_name } : null;
    
    // Generar el ticket utilizando el sistema de templates
    const content = ticketRenderer.renderPlainText(
      ticketTemplates[`${type}Ticket`]({
        business,
        sale,
        items: sale.items,
        customer
      }),
      type
    );
    
    setTicketContent(content);
  }, [sale, business, type]);

  return (
    <div className={`bg-white border border-gray-200 rounded-md shadow-sm ${className}`}>
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">
          Vista previa del ticket
          {type === 'delivery' && ' de entrega'}
          {type === 'fulfillment' && ' de preparación'}
          {type === 'backup' && ' de respaldo'}
        </h3>
      </div>
      <div className="p-4">
        <pre className="font-mono text-sm whitespace-pre-wrap bg-gray-50 p-4 rounded-md overflow-auto max-h-96">
          {ticketContent}
        </pre>
      </div>
    </div>
  );
} 